export const notificationEndpointIds = {
    CREATE_NOTIFICATION_TRIGGER: 'CREATE_NOTIFICATION_TRIGGER',
    CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
};
